;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { CSSProperties, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  justify?: 'center' | 'start' | 'end';
  className?: string;
  id?: string;
  background?: 'white' | 'blue';
  style?: CSSProperties;
  smallPadding?: boolean;
  stretch?: boolean;
};

export default function Card({
  children,
  className,
  id,
  justify = 'center',
  background = 'white',
  style,
  smallPadding = false,
  stretch = true,
}: Props) {
  return (
    <div
      id={id}
      className={`${smallPadding ? 'p-4' : 'p-5'} border rounded-xl d-flex flex-column ${background === 'white' ? 'bg-white' : ''} ${background === 'blue' && 'bg-blue'} justify-content-${justify} gap-4 ${className}`}
      style={{ borderColor: '#E8E9F3', minWidth: '100%', minHeight: stretch ? '100%' : undefined, ...style }}
    >
      {children}
    </div>
  );
}
